import { render } from "./UploadFileModal.vue?vue&type=template&id=24a252ac&scoped=true"
import script from "./UploadFileModal.vue?vue&type=script&lang=js"
export * from "./UploadFileModal.vue?vue&type=script&lang=js"

import "./UploadFileModal.vue?vue&type=style&index=0&id=24a252ac&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a252ac"]])

export default __exports__